import React, { useContext } from 'react';
import { LampOn, Book, Activity, ShieldTick, Microphone2 } from 'iconsax-react';
import NotificationItem from '../components/NotificationItem';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const sc = (n) => Math.round(n * SCALE);

const ICON_SIZE = sc(24);

const NOTIFICATION_DEFS = [
  { id: 1, Icon: LampOn,      message: 'Dr. Fredrik Johnson has shared an insightful tip for the week on parenting the right way.' },
  { id: 2, Icon: Book,        message: 'Your Freeform story is saved. Pick it up whenever you feel inspired.' },
  { id: 3, Icon: Activity,    message: 'Your post is now part of the trending community stories.' },
  { id: 4, Icon: Book,        message: 'Explore new trending seasonal stories in the library section.' },
  { id: 5, Icon: ShieldTick,  message: 'Looking for a calm bedtime story? Taleo has a gentle Read Mode suggestion waiting for you.' },
  { id: 6, Icon: Book,        message: 'You have a saved personalised story draft waiting to be completed.' },
  { id: 7, Icon: Microphone2, message: 'A new voice option is available for Listen Mode.' },
  { id: 8, Icon: Activity,    message: 'Someone responded to your post with a comment.' },
];

export default function NotificationsScreen() {
  const theme = useContext(ThemeContext);
  const notifications = NOTIFICATION_DEFS.map(({ id, Icon, message }) => ({
    id,
    icon: <Icon size={ICON_SIZE} variant="Linear" color={theme.text400} />,
    message,
  }));
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.bg100,
        overflow: 'hidden',
        padding: sc(16),
      }}
    >
      {/* White rounded card — left-aligned, ~half the content width */}
      <div
        style={{
          width: sc(560),
          height: '100%',
          backgroundColor: theme.cardBg,
          borderRadius: sc(30),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Heading */}
        <div
          className="font-satoshi font-bold"
          style={{
            flexShrink: 0,
            textAlign: 'center',
            fontSize: sc(18),
            lineHeight: `${sc(24)}px`,
            color: theme.text100,
            padding: `${sc(20)}px ${sc(32)}px ${sc(12)}px`,
          }}
        >
          Notifications
        </div>

        {/* Scrollable list */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: sc(12),
            padding: `${sc(4)}px ${sc(16)}px ${sc(16)}px`,
          }}
        >
          {notifications.map(n => (
            <NotificationItem key={n.id} icon={n.icon} message={n.message} />
          ))}
        </div>
      </div>
    </div>
  );
}
